import { RootState } from '../index';
import get from 'lodash/get';

export const getSavedForm = (formId: string) => (state: RootState) => {
  return get(state, ['forms', formId], null);
};
